function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwPanel from 'viewmodel/AwPanelViewModel';
import AwFlexRow from 'viewmodel/AwFlexRowViewModel';
import AwSplmTable from 'viewmodel/AwSplmTableViewModel';
import AwImage from 'viewmodel/AwImageViewModel';
import AwLink from 'viewmodel/AwLinkViewModel';
import { EnableWhen } from 'js/hocCollection';
const AwLinkEnableWhen = EnableWhen(AwLink);
AwLinkEnableWhen.displayName = 'AwLinkEnableWhen';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/appCtxService', () => import('js/appCtxService'));
registerDynImportEntry('js/rfqHelper', () => import('js/rfqHelper'));
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "actions": {
    "addSupplierExistToCtx": {
      "actionType": "JSFunction",
      "method": "updateCtx",
      "deps": "js/appCtxService",
      "inputData": {
        "name": "supplierExist",
        "value": true
      }
    },
    "performPostAddSupplierBatchAction": {
      "actionType": "batchJob",
      "steps": [{
        "action": "showTable"
      }, {
        "action": "refreshSuppliersTable"
      }]
    },
    "publishAddSupplierEvent": {
      "actionType": "JSFunction",
      "method": "publishEvent",
      "inputData": {
        "eventName": "add-supplier-event"
      },
      "deps": "js/rfqHelper"
    },
    "showTable": {
      "actionType": "JSFunction",
      "method": "showHideTable",
      "inputData": {
        "divId": "listSupplierTableDiv",
        "totalFound": "1"
      },
      "deps": "js/rfqHelper"
    },
    "showHideTable": {
      "actionType": "JSFunction",
      "method": "showHideTable",
      "inputData": {
        "divId": "listSupplierTableDiv",
        "totalFound": "{{data.totalFound}}"
      },
      "deps": "js/rfqHelper"
    },
    "getSuppliers": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "query getSuppliers( $collaborationspaceId: String, $rfqId: String, $skip: Int, $sort: Json, $filters: Json) { getSuppliers( collaborationspaceId: $collaborationspaceId, rfqId: $rfqId, skip: $skip, sort: $sort, filters: $filters) { items totalCount error}}",
            "variables": {
              "collaborationspaceId": "{{props.collaborationspaceid}}",
              "rfqId": "{{props.rfqid}}",
              "skip": "{{data.RfqSuppliersSkip}}",
              "sort": "{{data.columnProviders.exampleColumnProvider.sortCriteria}}",
              "filters": "{{data.columnProviders.exampleColumnProvider.columnFilters}}"
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{props.accsessionid}}"
      },
      "dataParsers": [{
        "id": "supplierParser",
        "responseObjs": "data.data.getSuppliers.items"
      }],
      "outputData": {
        "filterResults": "data.data.getSuppliers.items",
        "totalFound": "data.data.getSuppliers.totalCount",
        "error": "data.data.getSuppliers.error"
      },
      "actionMessages": {},
      "events": {
        "success": [{
          "condition": "error === null || error === undefined",
          "name": "list-suppliers-as-list.success"
        }, {
          "condition": "totalFound > 0",
          "name": "list-suppliers-as-list.supplierExist"
        }, {
          "condition": "error === 'EMPTY_COLLAB_SPACE'",
          "name": "list-suppliers-as-list.error",
          "eventData": {
            "error": "{{i18n.EMPTY_COLLAB_SPACE}}",
            "errorCode": 400
          }
        }, {
          "condition": "error.statusCode === 400 || errorCode === 400",
          "name": "list-suppliers-as-list.error",
          "eventData": {
            "error": "{{error}}",
            "errorCode": 400
          }
        }, {
          "condition": "error.statusCode === 403 || errorCode === 403",
          "name": "list-suppliers-as-list.error",
          "eventData": {
            "error": "{{i18n.FORBIDDEN}}",
            "errorCode": 403
          }
        }, {
          "condition": "error.statusCode === 401 || errorCode === 401 || errorCode === 'INVALID_ACC_SESSION_ID'",
          "name": "list-suppliers-as-list.error",
          "eventData": {
            "error": "{{i18n.UNAUTHORIZED}}",
            "errorCode": 401
          }
        }, {
          "condition": "error.statusCode >= 500 && error.statusCode <= 599",
          "name": "list-suppliers-as-list.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }],
        "failure": [{
          "name": "list-suppliers-as-list.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }]
      },
      "deps": "js/accHttpService"
    },
    "removeRfqSuppliers": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "mutation removeRfqSuppliers( $collaborationspaceId: String, $rfqId: String, $supplierIds: String) { removeRfqSuppliers( collaborationspaceId: $collaborationspaceId, rfqId: $rfqId, supplierIds: $supplierIds) }",
            "variables": {
              "collaborationspaceId": "{{ctx.rfq.collaborationspaceid || props.collaborationspaceid}}",
              "rfqId": "{{ctx.rfq.rfqid || props.rfqid}}",
              "supplierIds": "{{ctx.selectedSupplierIds}}"
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{ctx.rfq.accsessionid || props.accsessionid}}"
      },
      "outputData": {
        "response": "data.data.removeRfqSuppliers",
        "errorCode": "errorCode"
      },
      "events": {
        "success": [{
          "condition": "response.error === undefined",
          "name": "remove-rfq-suppliers.success",
          "eventData": {
            "response": "{{response}}"
          }
        }, {
          "condition": "response.error === 'EMPTY_COLLAB_SPACE'",
          "name": "remove-rfq-suppliers.error",
          "eventData": {
            "error": "{{i18n.EMPTY_COLLAB_SPACE}}",
            "errorCode": 400
          }
        }, {
          "condition": "response.error.statusCode === 400 || errorCode === 400",
          "name": "remove-rfq-suppliers.error",
          "eventData": {
            "error": "{{response.error}}"
          }
        }, {
          "condition": "response.error.statusCode === 403 || errorCode === 403",
          "name": "remove-rfq-suppliers.error",
          "eventData": {
            "error": "{{i18n.FORBIDDEN}}",
            "errorCode": 403
          }
        }, {
          "condition": "response.error.statusCode === 401 || errorCode === 401 || errorCode === 'INVALID_ACC_SESSION_ID'",
          "name": "remove-rfq-suppliers.error",
          "eventData": {
            "error": "{{i18n.UNAUTHORIZED}}",
            "errorCode": 401
          }
        }, {
          "condition": "response.error.statusCode >= 500 && response.error.statusCode <= 599",
          "name": "remove-rfq-suppliers.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }],
        "failure": [{
          "name": "remove-rfq-suppliers.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }]
      },
      "deps": "js/accHttpService"
    },
    "refreshSuppliersTable": {
      "actionType": "dataProvider",
      "method": "supplierDataProvider"
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventId}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/accEventBus"
    },
    "addSelectedSupplierIdsToCtx": {
      "actionType": "JSFunction",
      "method": "updateCtx",
      "deps": "js/appCtxService",
      "inputData": {
        "name": "selectedSupplierIds",
        "value": "{{parameters.eventData}}"
      }
    }
  },
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    },
    "rfqid": {
      "type": "string"
    }
  },
  "data": {
    "image1": {
      "dbValue": "/assets/image/typeProjectRequest48.svg"
    },
    "pageSize": 3,
    "RfqSuppliersSkip": 0,
    "noSupplierLink": {
      "displayName": "{{i18n.addSuppliers}}",
      "type": "STRING",
      "isRequired": "false"
    }
  },
  "dataProviders": {
    "supplierDataProvider": {
      "action": "getSuppliers",
      "response": "{{data.filterResults}}",
      "totalFound": "{{data.totalFound}}",
      "selectionModelMode": "single",
      "inputData": {
        "selectionModel": "{{subPanelContext.selectionModel}}"
      }
    }
  },
  "columnProviders": {
    "exampleColumnProvider": {
      "frozenColumnIndex": 0,
      "columns": [{
        "name": "email",
        "displayName": "{{i18n.emailId}}",
        "minWidth": 250,
        "width": 250,
        "enableColumnMenu": true,
        "pinnedLeft": true,
        "enableSorting": true,
        "isFilteringEnabled": true
      }, {
        "name": "id",
        "displayName": "{{i18n.supplierId}}",
        "minWidth": 250,
        "width": 250,
        "enableColumnMenu": false,
        "isFilteringEnabled": false,
        "enableSorting": false
      }, {
        "name": "rfqQuoteId",
        "displayName": "{{i18n.rfqQuoteId}}",
        "minWidth": 250,
        "width": 250,
        "enableColumnMenu": false,
        "pinnedLeft": true,
        "isFilteringEnabled": false,
        "enableSorting": false
      }, {
        "name": "status",
        "displayName": "{{i18n.status}}",
        "minWidth": 250,
        "width": 250,
        "enableColumnMenu": false,
        "isFilteringEnabled": false,
        "enableSorting": false
      }]
    }
  },
  "grids": {
    "supplierTable": {
      "dataProvider": "supplierDataProvider",
      "columnProvider": "exampleColumnProvider",
      "addIconColumn": false,
      "gridOptions": {
        "enableGridMenu": true,
        "enablePinning": true,
        "enableSorting": true,
        "isFilteringEnabled": true,
        "enableColumnHiding": true
      }
    }
  },
  "functions": {
    "filterRows": {
      "functionName": "filterRows",
      "parameters": ["{{data.dataProviders.supplierDataProvider.startIndex}}", "{{data.pageSize}}"]
    }
  },
  "i18n": {
    "emailId": ["RfqMessages"],
    "supplierId": ["RfqMessages"],
    "emptySuppliers": ["RfqMessages"],
    "addSuppliers": ["RfqMessages"],
    "ACC_SERVER_ERROR": ["errorMessages"],
    "EMPTY_COLLAB_SPACE": ["errorMessages"],
    "BAD_REQUEST_CREATE_RFQ": ["errorMessages"],
    "FORBIDDEN": ["errorMessages"],
    "UNAUTHORIZED": ["errorMessages"],
    "status": ["RfqMessages"],
    "rfqQuoteId": ["RfqMessages"]
  },
  "onEvent": [{
    "eventId": "list-suppliers-as-list.supplierExist",
    "action": "addSupplierExistToCtx",
    "cacheEventData": true
  }, {
    "eventId": "add-suppliers.success",
    "action": "addSupplierExistToCtx",
    "cacheEventData": true
  }, {
    "eventId": "list-suppliers-as-list.success",
    "action": "showHideTable",
    "cacheEventData": true
  }, {
    "eventId": "submit-rfq.success",
    "action": "refreshSuppliersTable",
    "cacheEventData": true
  }, {
    "eventId": "award-rfq.success",
    "action": "refreshSuppliersTable",
    "cacheEventData": true
  }, {
    "eventId": "add-suppliers.success",
    "action": "performPostAddSupplierBatchAction",
    "cacheEventData": true
  }, {
    "eventId": "list-suppliers-as-list.error",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-list-suppliers-as-list.error",
      "eventData": {
        "message": "{{eventData.error}}",
        "statusCode": "{{eventData.errorCode}}"
      }
    }
  }, {
    "eventId": "supplierDataProvider.selectionChangeEvent",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-list-suppliers-as-list.selected",
      "eventData": "{{eventData.selectedObjects[0].props.rfqQuoteId.dbValue}}"
    }
  }, {
    "eventId": "supplierDataProvider.selectionChangeEvent",
    "action": "addSelectedSupplierIdsToCtx",
    "inputArgs": {
      "eventId": "des-list-suppliers-as-list.selected",
      "eventData": "{{eventData.selectedObjects[0].props.id.dbValue}}"
    }
  }, {
    "eventId": "remove-rfq-supplier.error",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-remove-rfq-supplier.error",
      "eventData": {
        "message": "{{eventData.error}}",
        "statusCode": "{{eventData.errorCode}}"
      }
    }
  }, {
    "eventId": "remove-rfq-suppliers.success",
    "action": "getSuppliers",
    "cacheEventData": true
  }, {
    "eventId": "remove-rfq-suppliers.success",
    "action": "refreshSuppliersTable",
    "cacheEventData": true
  }, {
    "eventId": "remove-rfq-suppliers.success",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "remove-rfq-suppliers.success",
      "eventData": "{{eventData.response}}"
    }
  }, {
    "eventId": "removeRfqSupplierEvent",
    "action": "removeRfqSuppliers",
    "cacheEventData": true
  }, {
    "eventId": "removeRfqSupplierEvent",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-list-suppliers-as-list.success",
      "eventData": {
        "message": "{{ctx.selectedSupplierIds}}",
        "statusCode": "called"
      }
    }
  }, {
    "eventId": "remove-rfq-suppliers.success",
    "message": "deleteSuplierSuccess"
  }],
  "messages": {
    "deleteSuplierSuccess": {
      "messageType": "INFO",
      "messageText": "Supplier is removed successfully."
    }
  },
  "dataParseDefinitions": {
    "supplierParser": {
      "identifier": "{{response.supplierId}}",
      "typeIconURL": "http://localhost:4012/assets/images/typeShareFolder48.svg",
      "type": "SUPPLIER",
      "props": {
        "email": {
          "name": "{{i18n.emailId}}",
          "displayName": "{{i18n.emailId}}",
          "value": "{{response.email}}",
          "displayValue": "{{response.email}}",
          "type": "String"
        },
        "id": {
          "name": "{{i18n.supplierId}}",
          "displayName": "{{i18n.supplierId}}",
          "value": "{{response.id}}",
          "displayValue": "{{response.id}}",
          "type": "String"
        },
        "rfqQuoteId": {
          "name": "{{i18n.rfqQuoteId}}",
          "displayName": "{{i18n.rfqQuoteId}}",
          "value": "{{response.rfqQuoteId}}",
          "displayValue": "{{response.rfqQuoteId}}",
          "type": "String"
        },
        "status": {
          "name": "{{i18n.status}}",
          "displayName": "{{i18n.status}}",
          "value": "{{response.status}}",
          "displayValue": "{{response.status}}",
          "type": "String"
        }
      }
    }
  },
  "conditions": {
    "enableRfq": {
      "expression": "!(ctx.rfqStatus === 'Closed' || ctx.rfqStatus === 'Awarded' || ctx.rfqStatus === 'Expired')"
    }
  },
  "_viewModelId": "ListSuppliersAsList",
  "_uniqueViewModelId": "ListSuppliersAsList",
  "ctx": {
    "rfq": {
      "type": "object"
    },
    "selectedSupplierIds": {
      "type": "object"
    },
    "rfqStatus": {
      "type": "object"
    }
  }
};

/*
<aw-panel class="aw-layout-full">
    <aw-flex-row>
        <div id = "listSupplierTableDiv" class="rfqHidden">
        <aw-splm-table gridid="supplierTable"></aw-splm-table>
    </div>
        <br>
        <div id="listSupplierTableDiv-empty" class="rfqEmptyPage">
            <br>
            <aw-image source="data.image1.dbValue" class="emptyImage"></aw-image>
            <br>
            <h2>{{i18n.emptySuppliers}}</h2>
            <br>
            <h3><aw-link class="emptyLink" enable-when="conditions.enableRfq"v prop="data.noSupplierLink" action="publishAddSupplierEvent"></aw-link></h3>
        </div>
    </aw-flex-row>
</aw-panel>

*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement(AwPanel, {
    revealAction: actions.reveal,
    className: "aw-layout-full"
  }, /*#__PURE__*/React.createElement(AwFlexRow, null, /*#__PURE__*/React.createElement("div", {
    id: "listSupplierTableDiv",
    className: "rfqHidden"
  }, /*#__PURE__*/React.createElement(AwSplmTable, grids.supplierTable)), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    id: "listSupplierTableDiv-empty",
    className: "rfqEmptyPage"
  }, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(AwImage, {
    source: AwParseService.instance("data.image1.dbValue")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    className: "emptyImage"
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h2", null, AwParseService.instance("i18n.emptySuppliers")({
    props,
    data,
    fields,
    dataProviders,
    ctx,
    i18n,
    actions,
    subPanelContext,
    viewPath,
    conditions,
    formProp,
    dispatch,
    selectionModels,
    editHandlers,
    chartProviders,
    ports
  })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(AwLinkEnableWhen, _extends({
    className: "emptyLink"
  }, getField("data.noSupplierLink", fields, $index, null, null), {
    action: actions.publishAddSupplierEvent,
    enableWhen: AwParseService.instance("conditions.enableRfq")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }))))));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;